import React, { Component } from 'react';
import styled from 'styled-components';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import Flag from '../shared/Flag';

import { maxWidth, minWidth } from '../../helpers/media-queries';

import formatNumber from '../../helpers/format-number';


const Dots = styled.span.attrs({
    className: 'dots',
}) `
    &:before {
        content: '.....................................................................';
        letter-spacing: 5px;
    }
`;

const styles = ({ palette, sizes }) => ({
    root: {
        width: '100%',
        marginTop: sizes.baseSize+'px',
        '& tbody': {
            width: '50%',
            float: 'left',
            border: 'none !important',
            [maxWidth.md]: {
                width: '100%',
                float: 'none'
            },
            [minWidth.md]: {
                '&:first-child': {
                    paddingRight: '10px',
                },
                '&:last-child': {
                    paddingLeft: '10px',
                }
            },
        },
        '& tr': {
            backgroundColor: 'none',
        },
        '& td, & th': {
            verticalAlign: 'middle',
            border: 'none',
            padding: '0 0.75em',
            width: '50%',

            '& > div': {
                color: '#ffffff',
                fontFamily: "'zx_spectrum7_boldregular', sans",
                fontSize: '2em',    
                display: 'flex',
                flex: '1',
                maxWidth: '355px',
                alignItems: 'center',
                justifyContent: 'space-between',
                textTransform: 'uppercase',
                '& .flag': {
                    display: 'inline-block',
                    marginRight: '0.25em',
                    marginLeft: '0.25em',
                },
                '& .dots': {
                    marginRight: '0.25em',
                    marginLeft: '0.25em',
                    paddingBottom: '0.5em',
                    display: 'flex',
                    flex: 1,
                    overflow: 'hidden',
                },
                [maxWidth.lg]: {
                    maxWidth: '38vw',
                },
                [maxWidth.md]: {
                    maxWidth: '68vw',
                }
            }
        }
    },

    row: {
        '&.me': {
            
            verticalAlign: 'middle',
            border: 'none',
            padding: '0 0.75em',
            width: '100%',

            '& > div': {
                fontFamily: "'zx_spectrum7_boldregular', sans",
                fontSize: '2em',    
                display: 'flex',
                flex: '1',
                maxWidth: '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
                textTransform: 'uppercase',
                '& .flag': {
                    display: 'inline-block',
                    marginRight: '0.25em',
                    marginLeft: '0.25em',
                },
                '& .dots': {
                    marginRight: '0.25em',
                    marginLeft: '0.25em',
                    paddingBottom: '0.5em',
                    display: 'flex',
                    flex: 1,
                    overflow: 'hidden',
                },
                [maxWidth.md]: {
                    maxWidth: '68vw',
                }
            },
        },
        '&.me div': {
            color: '#F9DB53',
        },
        '&.top td div': {
            color: '#F9DB53',
        }
    }
});

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
    ranking: stores.ranking.ranking,
});

class Table extends Component {
    render() {
        const { classes } = this.props;
        const ranking = this._prepareRanking();

        let me = [...ranking][2];
        if (me && me[0]) me = me[0];
        
        return (
            <React.Fragment>                
                <table className={classNames('table', classes.root)}>
                    {/* <thead>
                        {this._renderHeader()}
                    </thead> */}
                    <tbody>
                        {[...this._generateRows([...ranking][0])]}
                    </tbody>
                    <tbody>
                        {[...this._generateRows([...ranking][1])]}
                    </tbody>
                </table>
                {!!me ? (
                    <div
                        style={{
                            paddingRight: '1.35em',
                        }}
                        className={classNames(classes.row, {
                            me: true,
                        })}>
                        <div
                            style={{
                                borderTop: '1px solid rgba(255,255,255,0.5)'
                            }}>                            
                            {me.position}. <Flag className="flag" country={me.country_id || 0}/> {me.name} <Dots /> {formatNumber(me.score)}
                        </div>
                    </div>
                ) : (null)}
            </React.Fragment>
        )
    }

    *_generateRows(ranking) {
        ranking = ranking || [];
        ranking = ranking.entries();

        for(const [i, entry] of ranking) {
            yield this._renderRow(`tr-${i}`, entry);
        }
    }

    _renderHeader() {
        const { classes, intl } = this.props;
        return (
            <tr className={classes.row}>
                <th>#</th>
                <th>{intl["LOCALE.RANKING.HEADER.NAME"]}</th>
                <th>{intl["LOCALE.RANKING.HEADER.COUNTRY"]}</th>
                <th>{intl["LOCALE.RANKING.HEADER.SCORE"]}</th>
            </tr>
        );
    }

    _renderRow(key, entry) {
        
        if (entry && entry.hide) return (null);

        const { classes } = this.props;
        // Keep references to named entries
        let ref = this.refs[key];
        if (!ref) {
            ref = React.createRef();
            this.refs = Object.assign({}, this.refs, { [key]: ref });
        }

        return (
            <tr
                className={classNames(classes.row, {
                    me: entry.me,
                })}
                ref={ref}
                key={key}>
                <td>
                    <div>
                        {entry.position}. <Flag className="flag" country={entry.country_id || 0}/> {entry.name} <Dots /> {formatNumber(entry.score)}
                    </div>
                </td>
            </tr>
        );
    }

    _prepareRanking = () => {
        const { ranking } = this.props;
        if (!ranking) return [[], []];
        if (ranking.length < 6) return [[...ranking].slice(0, ranking.length)];
        if (ranking.length < 10) return [[...ranking].slice(0, 5), [...ranking].slice(5, ranking.length)];
        if (ranking[10]) return [[...ranking].slice(0, 5), [...ranking].slice(5, 10), [...ranking].slice(10, 11)];
        return [[...ranking].slice(0, 5), [...ranking].slice(5, 10)];
    }
}

export default inject(mapper)(
    withStyles(styles)(Table)
);